import { motion } from 'motion/react';
import styles from './Question.module.css';
import { useGetParams } from '../../hooks/useGetParams';

function Question({ title, initDelay }) {
  const { questionFontSize } = useGetParams();

  const questionLines = title?.split(/\r?\n/);

  const isLong = questionLines?.find((l) => l.length > 45);

  return (
    <div
      key={title}
      className={styles.question}
      style={{
        fontSize: isLong
          ? `${0.8 * questionFontSize}rem`
          : `${questionFontSize}rem`,
      }}
    >
      {questionLines[0] && (
        <motion.div
          className={styles.line}
          initial={{ x: '-100%' }}
          animate={{ x: 0 }}
          transition={{ duration: 1.56, delay: initDelay }}
        >
          <div>{questionLines[0]}</div>
        </motion.div>
      )}
      {questionLines[1] && (
        <motion.div
          className={styles.line}
          initial={{ x: '-100%' }}
          animate={{ x: 0 }}
          transition={{ duration: 1.56, delay: initDelay + 0.36 }}
        >
          <div>{questionLines[1]}</div>
        </motion.div>
      )}
    </div>
  );
}

export default Question;
